<template>
  <v-row>
    <v-col cols="12" class="py-0 px-6">
      <v-card flat class="about-box-shadow">
        <div class="d-flex justify-space-between border-bottom">
          <v-card-title class="text-about px-0 py-2"> About </v-card-title>
          <img
            class="icon-cursor"
            src="@/assets/icons/typeedit.svg"
            @click="toggleComponentOne()"
          />
          <!-- <v-divider class="my-1 mx-3"></v-divider>
              <delete-bio @ShortBio="ShortBio"></delete-bio> -->
        </div>
        <v-card-text class="pa-0" v-if="bio && !showComponentEdit">
          <v-col cols="12" class="about-text px-0">
            <span v-if="bio">
              {{ bio }}
            </span>
          </v-col>
        </v-card-text>
        <v-card-text class="pa-0" v-if="!bio && !showComponentEdit">
          <v-col cols="12" class="about-text text-center px-0">
            <span> No bio added </span>
          </v-col>
        </v-card-text>
        <v-card-text class="pa-0" v-if="showComponentEdit">
          <v-col cols="12" class="about-text px-0">
            <edit-short-bio
              :shortBioInformation="bio"
              @hideBioComponent="showComponentEdit = false"
            ></edit-short-bio>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import EditShortBio from "./EditShortBio";
// import AddShortBio from "./AddShortBio";
// import DeleteBio from "./DeleteBio";

export default {
  name: "ShortBioSection",
  components: {
    EditShortBio,
    // AddShortBio,
    // DeleteBio
  },
  data() {
    return {
      showComponentEdit: false,
    };
  },
  props: {
    bio: String,
  },
  methods: {
    toggleComponentOne() {
      this.showComponentEdit = !this.showComponentEdit;
    },/* 
    ShortBio(data) {
      this.$emit("bioUpdated", data);
      // document.getElementById("action").click();
    }, */
  },
};
</script>
<style scoped>
about-box-shadow {
  box-shadow: none !important;
}
.text-about {
  font-weight: 500;
  font-size: 18px;
  color: #434343;
}
.border-bottom {
  border-bottom: 1px solid #e1e1e1;
}
.about-text {
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  text-align: justify;
  color: #122d4f;
}
.icon-cursor {
  cursor: pointer;
}
</style>